
import { Button } from "@/components/ui/button";
import { AlertCircle, BarChart } from "lucide-react";
import React from "react";

const AdminDashboardHeader = () => (
  <div className="flex justify-between items-center mb-6">
    <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
    <div className="flex items-center space-x-4">
      <Button variant="outline" className="flex items-center">
        <AlertCircle className="mr-2 h-4 w-4" />
        Notifications
      </Button>
      <Button variant="outline" className="flex items-center">
        <BarChart className="mr-2 h-4 w-4" />
        Reports
      </Button>
    </div>
  </div>
);

export default AdminDashboardHeader;
